import React from 'react';
import './FAQ.css';

const FAQ = () => {
  return (
    <section id="faq" className="faq">
      <div className="faq-container">
        <div className="faq-header">
          <h2 className="section-title" data-aos="fade-up">
            Frequently Asked <span className="gradient-text">Questions</span>
          </h2>
          <p className="section-description" data-aos="fade-up" data-aos-delay="100">
            Find answers to common questions about StoryCape
          </p>
        </div>
        
        <div className="faq-grid" data-aos="fade-up">
          <div className="faq-item">
            <h4>Can I upgrade my plan later?</h4>
            <p>Yes, you can upgrade your plan at any time as your app grows.</p>
          </div>
          <div className="faq-item">
            <h4>What happens if I exceed my MAU limit?</h4>
            <p>We'll notify you when you're approaching your limit and discuss options.</p>
          </div>
          <div className="faq-item">
            <h4>Do you offer a free trial?</h4>
            <p>Contact our sales team to arrange a demo and trial period.</p>
          </div>
          <div className="faq-item">
            <h4>How is MAU calculated?</h4>
            <p>MAU is calculated based on unique users who view your stories each month.</p>
          </div>
          <div className="faq-item">
            <h4>What platforms do you support?</h4>
            <p>Our SDK supports both iOS and Android platforms.</p>
          </div>
          <div className="faq-item">
            <h4>Can I customize the look and feel?</h4>
            <p>Yes, our SDK is fully customizable to match your app's design.</p>
          </div>
        </div>
      </div>
      
      <div className="faq-shapes">
        <div className="faq-shape faq-shape-1"></div>
        <div className="faq-shape faq-shape-2"></div>
      </div>
    </section>
  );
};

export default FAQ;